"use strict";

require("core-js/modules/es6.function.name");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform = require("platform");

var ClientInfo = function ClientInfo(version) {
  _classCallCheck(this, ClientInfo);

  this.sdk = 'js';
  this.sdkVer = version;
  this.os = platform.os.family;
  this.osVer = platform.os.version;
  this.pl = platform.name;
  this.plVer = platform.version;
};

exports.ClientInfo = ClientInfo;
exports["default"] = ClientInfo;